// 资产卡片组件
export default {
  // 图表标题
  assetDistribution: "资产分布",
  totalAssetBalanceChange: "总资产余额变化(近六个月)",
  unit: "单位：USDT",

  // 提示信息
  dataCalculating: "总资产余额变化数据计算中，请稍后查看",
};
